<div class="grid">
  <div class="col-8">
    <p-tabView [(activeIndex)]="activeIndex">
      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-comments"></i>
          <span class="screen ml-2">Messaggi</span>
        </ng-template>
        <div class="flex flex-column gap-2">
          <div class="messages">
            @if(user){ @for(c of chatMessages; track $index){
            <div
              class="message"
              [class]="c.user_id === 1 ? 'incoming' : 'outgoing'"
            >
              <img [src]="user.profile_picture | imagePipe : 'user' : 'sm'" />
              <div class="message-content">
                <div class="message-bubble">
                  {{ c.text }}
                </div>
                <div class="message-meta">
                  {{ c.when | date : "dd/MM/YYYY HH:mm" }}
                </div>
              </div>
            </div>
            } }
          </div>
          <div class="composer">
            <div class="grid">
              <div class="col-9">
                <textarea rows="3" pInputTextarea class="w-full"></textarea>
              </div>
              <div class="col">
                <p-menu
                  #menu
                  [model]="attachments_menu"
                  appendTo="body"
                  [popup]="true"
                />
                <div class="flex gap-2 h-full flex-column">
                  <p-button
                    size="small"
                    type="button"
                    (click)="menu.toggle($event)"
                    class="attachmentBtn"
                    label="Allega file"
                  />
                  <p-button
                    size="small"
                    type="button"
                    class="sendBtn"
                    label="Invia"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="pi pi-folder-open"></i>
          <span class="screen ml-2">I miei preventivi</span>
        </ng-template>
        <div class="flex mt-4 mb-2">
          <p-button
            label="Crea preventivo"
            size="small"
            styleClass="slide-o px-6"
            type="submit"
          ></p-button>
        </div>
        <p-table [value]="files" stripedRows [paginator]="true" [rows]="5">
          <ng-template pTemplate="body" let-f>
            <tr>
              <td>
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-file-pdf text-2xl text-400"></i>
                  {{ f.label }}
                </div>
              </td>
              <td>{{ f.when | date : "dd/MM/YYYY HH:mm" }}</td>
              <td>
                <div class="flex align-items-center gap-2 justify-content-end">
                  <p-button
                    [outlined]="true"
                    size="small"
                    type="button"
                    icon="pi pi-paperclip"
                    pTooltip="Invia"
                    tooltipPosition="left"
                  />
                  <p-button
                    [outlined]="true"
                    size="small"
                    type="button"
                    icon="pi pi-download"
                    pTooltip="Scarica"
                    tooltipPosition="left"
                  />
                  <p-button
                    [outlined]="true"
                    size="small"
                    type="button"
                    icon="pi pi-times"
                    pTooltip="Elimina"
                    tooltipPosition="left"
                  />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
    </p-tabView>
  </div>
  <div class="col">
    <h3>Richiesta</h3>
    @if(user){
    <div class="from-user">
      <img [src]="user.profile_picture | imagePipe : 'user' : 'md'" />
      <h5>{{ user.name }} {{ user.last_name }}</h5>
      <div class="content">
        <h6>Periodo</h6>
        <p>Ottobre 2025</p>
        <h6>Budget indicativo</h6>
        <p>€ 3.000</p>
        <h6>Tipo di viaggio</h6>
        <p>Pellegrinaggio</p>
        <h6>Destinazione</h6>
        <p>Israele</p>
        <h6>Dimensione del gruppo</h6>
        <p>5 - 10</p>
        <h6>Messaggio</h6>
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quisquam
          itaque nesciunt aspernatur earum. Ipsam tenetur, ex molestias placeat
          repellat reiciendis assumenda blanditiis ipsa itaque harum aut,
          possimus laboriosam vero dolor, sequi earum saepe sunt nesciunt ut
          nobis doloremque. Illum, hic.
        </p>
      </div>
    </div>
    }
  </div>
</div>
